import { Duration } from "luxon";
import { AnalyticsValueUnit } from "./__generated__/SinglePeriodTable.graphql";
import { useCallback } from "react";
import { useIntl } from "react-intl";

export function formatDuration(diff: Duration) {
  if (diff.as("hour") > 1) {
    return diff.shiftTo("hours").toHuman({
      maximumFractionDigits: 0,
      unitDisplay: "short",
    });
  }
  return diff.shiftTo("minutes").normalize().toHuman({
    maximumFractionDigits: 0,
    unitDisplay: "short",
  });
}

export function useFormatValueUnit() {
  const intl = useIntl();
  const formatValueUnit = useCallback(
    (value: number | null | undefined, valueUnit: AnalyticsValueUnit) => {
      if (value === null || value === undefined) {
        return "-";
      }
      switch (valueUnit) {
        case "duration":
          return formatDuration(Duration.fromObject({ seconds: value }));
        case "percentage":
          return `${Math.round(value)}%`;
        default:
          return intl.formatNumber(value);
      }
    },
    [intl]
  );

  return formatValueUnit;
}
